import React from "react";
import { useQuery } from "@apollo/react-hooks";

const Query = ({ children, query, slug, variables }) => {
  const { data, loading, error } = useQuery(query, {
    variables: { slug: slug, ...variables },
  });

  if (loading) return "";
  if (error) return <p>Error: {JSON.stringify(error)}</p>;
  return children({ data });
};

export default Query;
